const breastSymptoms=[

    {symptom:"breastLump",
    displayAs:"Unexplained breast lump",
    questionGroup: "breastLump"
    },
    
    {symptom:"nippleDischarge",
    displayAs:"Unilateral nipple discharge",
    questionGroup: "nippleDischarge"
    },
    
    {symptom:"nippleRetraction",
    displayAs: "Unilateral nipple retraction",
    questionGroup: "nippleRetraction"
    },

    {symptom:"breastOther",
    displayAs: "Other concerning breast changes",
    questionGroup: "sideDescriptionDuration"
    },

    {symptom:"breastSkinChanges",
    displayAs:"Skin changes suggesting breast cancer",
    questionGroup: "breastSkin"  
    },

    {symptom:"axillaLump",
    displayAs:"Unexplained lump in axilla",
    questionGroup: "axillaLump"  
    }

    ]

export default breastSymptoms